import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVisualAssortment = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.74816 3.06434C2.74816 2.85723 2.91605 2.68934 3.12316 2.68934L4.49448 2.68934C4.70159 2.68934 4.86948 2.85723 4.86948 3.06434V4.43566C4.86948 4.64277 4.70159 4.81066 4.49448 4.81066H3.12316C2.91605 4.81066 2.74816 4.64277 2.74816 4.43566V3.06434Z",
			stroke: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.75 2.25C0.75 1.42157 1.42157 0.75 2.25 0.75H5.25C6.07843 0.75 6.75 1.42157 6.75 2.25V5.25C6.75 6.07843 6.07843 6.75 5.25 6.75H2.25C1.42157 6.75 0.75 6.07843 0.75 5.25V2.25Z",
			stroke: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.3125 11.2757C5.0625 11.7087 5.0625 12.7913 4.3125 13.2243C3.5625 13.6573 2.625 13.116 2.625 12.25C2.625 11.384 3.5625 10.8427 4.3125 11.2757Z",
			stroke: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.75 10.75C0.75 9.92157 1.42157 9.25 2.25 9.25H5.25C6.07843 9.25 6.75 9.92157 6.75 10.75V13.75C6.75 14.5784 6.07843 15.25 5.25 15.25H2.25C1.42157 15.25 0.75 14.5784 0.75 13.75V10.75Z",
			stroke: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0377 11.1183C12.1734 11.0121 12.3641 11.0121 12.4999 11.1183L13.2258 11.6863C13.3476 11.7816 13.3984 11.9419 13.3538 12.09L13.0656 13.0452C13.0178 13.2035 12.872 13.3118 12.7066 13.3118H11.831C11.6656 13.3118 11.5197 13.2035 11.4719 13.0452L11.1838 12.09C11.1391 11.9419 11.1899 11.7816 11.3117 11.6863L12.0377 11.1183Z",
			stroke: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.25 10.75C9.25 9.92157 9.92157 9.25 10.75 9.25H13.75C14.5784 9.25 15.25 9.92157 15.25 10.75V13.75C15.25 14.5784 14.5784 15.25 13.75 15.25H10.75C9.92157 15.25 9.25 14.5784 9.25 13.75V10.75Z",
			stroke: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9252 2.8125C12.0696 2.5625 12.4304 2.5625 12.5748 2.8125L13.3867 4.21875C13.531 4.46875 13.3506 4.78125 13.0619 4.78125H11.4381C11.1494 4.78125 10.969 4.46875 11.1133 4.21875L11.9252 2.8125Z",
			stroke: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.25 2.25C9.25 1.42157 9.92157 0.75 10.75 0.75H13.75C14.5784 0.75 15.25 1.42157 15.25 2.25V5.25C15.25 6.07843 14.5784 6.75 13.75 6.75H10.75C9.92157 6.75 9.25 6.07843 9.25 5.25V2.25Z",
			stroke: "var(--main-color)"
		})
	]
});
export { SvgVisualAssortment as ReactComponent };
